import { Heart } from "lucide-react";
import { toast } from "sonner";
import { useFavourites } from "@/context/FavouritesContext";

export const FavButton = ({ id, title, className = "", testId }) => {
  const { has, toggle } = useFavourites();
  const on = has(id);
  const click = (e) => {
    e.preventDefault();
    e.stopPropagation();
    toggle(id);
    toast(on ? `Removed ${title} from your shortlist` : `Saved ${title} to your shortlist`);
  };
  return (
    <button type="button" onClick={click} aria-pressed={on} aria-label={on ? "Remove from shortlist" : "Save to shortlist"}
      data-testid={testId} className={`inline-flex items-center justify-center transition-transform duration-200 hover:scale-110 ${className}`}>
      <Heart size={18} className={on ? "fill-current" : ""} />
    </button>
  );
};
